import React from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EventIcon from '@mui/icons-material/Event';
import GridViewIcon from '@mui/icons-material/GridView';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import { Box } from '@mui/material';

import { type CategoryConfig, type CategoryType } from '@/types/category.types';

export const CATEGORY_CONFIG: Record<CategoryType, CategoryConfig> = {
  crypto: {
    title: 'Crypto',
    dividerAfter: 'etf',
  },
  finance: {
    title: 'Finance',
    dividerAfter: 'monthly',
  },
} as const;
